export interface DeviceConfig {
  id: string;
  metrics: MetricOption[];
  dateRanges: DateRangeOption[];
}


export interface DeviceHistoryRecord {
  timestamp: string;
  [key: string]: number | string;
  }

  
  export interface MetricOption {
    label: string;  // for display in dropdown
    value: string;  // for sending to API
    img_path?:ImageDetail,
    img_path2?:ImageDetail,
    img_path_off?:ImageDetail,
    img_path2_off?:ImageDetail,
    unit?:string,
    graph_type?:string 
    graph_value?:string
  }

  export interface ImageDetail{
    path?:string,
    unit?:string
  }
  

  export interface DateRangeOption {
    label: string;            // Shown in dropdown
    value: string;            // Internal key (e.g., 'TODAY')
    aggregate_filter: string;
    parameters?:string[] // e.g., 'day', 'week'
  }



  export const DEVICE_CONFIGS: DeviceConfig[] = [
    {
      id: 'HeatPump',
      metrics: [
        { label: 'Inlet temperature', value: 'temperature',img_path:{unit:"° C"} },
        { label: 'Outlet temperature', value: 'outlet_temperature',img_path:{unit:"° C"} },
        { label: 'Voltage', value: 'voltage',img_path:{path:"assets/img/voltage.svg",unit:"V"}, img_path_off:{path:"assets/img/voltage-off.svg",unit:"V"}},
      ],
      dateRanges: [
        { label: 'TODAY', value: 'TODAY', aggregate_filter: 'day' },
        { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: 'day' },
        { label: 'LAST WEEK', value: 'LAST_WEEK', aggregate_filter: 'week' },
        { label: 'LAST MONTH', value: 'LAST_MONTH', aggregate_filter: 'month' },
        { label: 'LAST YEAR', value: 'LAST_YEAR', aggregate_filter: 'year' },
        { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
      ]
    },
    {
        id: 'HeatPumpSg',
        metrics: [
          { label: 'Inlet temperature', value: 'temperature', img_path:{unit:"° C"} },
          { label: 'Outlet temperature', value: 'outlet_temperature', img_path:{unit:"° C"} },
          { label: 'Voltage', value: 'voltage',img_path:{path:"assets/img/voltage.svg",unit:"V"}, img_path_off:{path:"assets/img/voltage-off.svg",unit:"V"} },
        ],
          dateRanges: [
            { label: 'TODAY', value: 'TODAY', aggregate_filter: 'day' },
            { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: 'day' },
            { label: 'LAST WEEK', value: 'LAST_WEEK', aggregate_filter: 'week' },
            { label: 'LAST MONTH', value: 'LAST_MONTH', aggregate_filter: 'month' },
            { label: 'LAST YEAR', value: 'LAST_YEAR', aggregate_filter: 'year' },
            { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
          ]    
    },
        {
          id: 'VsPump',
          metrics: [
            { label: 'Motor speed', value: 'rpm',img_path:{unit:"RPM"} },
            { label: 'Power consumption', value: 'input_power' ,img_path:{path:"assets/img/power-consumption.svg",unit:"W"}, img_path_off:{path:"assets/img/power-consumption-off.svg",unit:"W"}},
              ]  ,
            dateRanges: [
              { label: 'TODAY', value: 'TODAY', aggregate_filter: '' },
              { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: '' },
              { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
            ]    
          },
  
    {
      id: 'SaltChlorinator',
      metrics: [
        { label: 'Ph', value: 'ph', img_path:{unit:""} },
        { label: 'Temperature', value: 'temperature',img_path:{path:"assets/img/temperature.svg", unit:"° C", }, img_path_off:{path:"assets/img/temperature-off.svg", unit:"° C", }},
        { label: 'Orp', value: 'orp', img_path:{unit:"mV"} },
        { label: 'Salt', value: 'salt',img_path:{unit:"g/l"} },
        { label: 'Cell life', value: 'cell_life',graph_type:'bar_graph',img_path:{path:"assets/img/cell-life.svg",unit:"%" },img_path_off:{path:"assets/img/cell-life-off.svg", unit:"%", },graph_value:"cell_status"},
        { label: 'Cell current', value: 'cell_current',img_path:{path:"assets/img/cell-current1.svg",unit:"A"}, img_path_off:{path:"assets/img/cell-current-off.svg",unit:"A"} },
        { label: 'Cell production', value: 'production_percentage',img_path:{path:"assets/img/cell_production.svg",unit:"%"}, img_path_off:{path:"assets/img/cell-production-off.svg",unit:"%"}},
        { label: 'Pool cover', value: 'pool_cover_status',graph_type:'bar_graph',img_path2:{path:"assets/img/pool-cover-open.svg",unit:"Open"}, img_path2_off:{path:"assets/img/pool-cover-open-off.svg",unit:"Open"},img_path:{path:"assets/img/pool-cover-close.svg",unit:"Close"}, img_path_off:{path:"assets/img/pool-cover-close-off.svg",unit:"Close"}},
          ]  ,
          dateRanges: [
            { label: 'TODAY', value: 'TODAY', aggregate_filter: 'day' },
            { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: 'day' },
            { label: 'LAST WEEK', value: 'LAST_WEEK', aggregate_filter: 'week',parameters:["Cell life","Pool cover"] },
            { label: 'LAST MONTH', value: 'LAST_MONTH', aggregate_filter: 'month',parameters:["Cell life","Pool cover"] },
            { label: 'LAST YEAR', value: 'LAST_YEAR', aggregate_filter: 'year',parameters:["Cell life","Pool cover"] },
            { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
          ] 
        },
        {
          id: 'DosingPump',
          metrics: [
            { label: 'Ph', value: 'ph',img_path:{unit:""} },
            { label: 'Temperature', value: 'temperature',img_path:{path:"assets/img/temperature.svg",unit:"° C"}, img_path_off:{path:"assets/img/temperature-off.svg",unit:"° C"} },
            { label: 'Orp', value: 'orp',img_path:{unit:"mV"} },
        { label: 'Pool cover', value: 'pool_cover_status',graph_type:'bar_graph',img_path2:{path:"assets/img/pool-cover-open.svg",unit:"Open"}, img_path2_off:{path:"assets/img/pool-cover-open-off.svg",unit:"Open"},img_path:{path:"assets/img/pool-cover-close.svg",unit:"Close"}, img_path_off:{path:"assets/img/pool-cover-close-off.svg",unit:"Close"}},
              ]  ,
              dateRanges: [
                { label: 'TODAY', value: 'TODAY', aggregate_filter: 'day' },
                { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: 'day' },
                { label: 'LAST WEEK', value: 'LAST_WEEK', aggregate_filter: 'week',parameters:["Cell life","Pool cover"] },
                { label: 'LAST MONTH', value: 'LAST_MONTH', aggregate_filter: 'month',parameters:["Cell life","Pool cover"] },
                { label: 'LAST YEAR', value: 'LAST_YEAR', aggregate_filter: 'year',parameters:["Cell life","Pool cover"] },
                { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
              ] 
        },
        {
          id: 'Aux3',
          metrics: [
            { label: 'Status', value: 'status',graph_type:'bar_graph' },
              ]  ,
              dateRanges: [
                { label: 'TODAY', value: 'TODAY', aggregate_filter: '' },
                { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: '' },
                { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
              ] 
            },
            {
              id: 'Aux4',
              metrics: [
                { label: 'Status', value: 'status',graph_type:'bar_graph' },
                  ]  ,
                  dateRanges: [
                    { label: 'TODAY', value: 'TODAY', aggregate_filter: '' },
                    { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: '' },
                    { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
                  ] 
        },
        {
          id: 'PoolLight',
          metrics: [
            { label: 'Status', value: 'status',graph_type:'bar_graph' },
              ]  ,
              dateRanges: [
                { label: 'TODAY', value: 'TODAY', aggregate_filter: '' },
                { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: '' },
                { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
              ] 
            },
            {
              id: 'UvLamp',
              metrics: [
                { label: 'Status', value: 'status',graph_type:'bar_graph' },
                  ]  ,
                  dateRanges: [
                    { label: 'TODAY', value: 'TODAY', aggregate_filter: '' },
                    { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: '' },
                    { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
                  ] 
        },
        {
            id: 'WaterMeter',
            metrics: [
              { label: 'Instantaneous flow', value: 'instantaneous_flow',img_path:{path:"assets/img/instant-water.svg",unit:"m³/h" } },
              { label: 'Positive cumulative flow', value: 'positive_cumulative_flow',img_path:{path:"assets/img/positive-water.svg",unit:"m³" } },
              { label: 'Reverse cumulative flow', value: 'reverse_cumulative_flow',img_path:{path:"assets/img/reverse-water-meter.svg",unit:"m³" } },
              { label: 'Temperature', value: 'water_temperature',img_path:{path:"assets/img/temperature.svg",unit:"° C" } },
                ]  ,
                dateRanges: [
                  { label: 'TODAY', value: 'TODAY', aggregate_filter: 'day' },
                  { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: 'day' },
                  { label: 'LAST WEEK', value: 'LAST_WEEK', aggregate_filter: 'week' },
                  { label: 'LAST MONTH', value: 'LAST_MONTH', aggregate_filter: 'month' },
                  { label: 'LAST YEAR', value: 'LAST_YEAR', aggregate_filter: 'year' },
                  { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
                ] 
        },
        {
          id: 'BackWash',
          metrics: [
            { label: 'Status', value: 'status',graph_type:'bar_graph' },
              ]  ,
              dateRanges: [
                { label: 'TODAY', value: 'TODAY', aggregate_filter: '' },
                { label: 'YESTERDAY', value: 'YESTERDAY', aggregate_filter: '' },
                { label: 'CUSTOM', value: 'LAST_YEAR', aggregate_filter: 'year' }
              ] 
            },

  ];

  export const GpioConfig = [
    {device_status:"turn_off",img:"assets/img/aux_off.svg",device_id :"Aux3"},
    {device_status:"turn_on",img:"assets/img/aux-off.svg",device_id:"Aux3"},
    {device_status:"turn_off",img:"assets/img/aux_off.svg",device_id :"Aux4"},
    {device_status:"turn_on",img:"assets/img/aux-off.svg",device_id:"Aux4"},
    {device_status:"turn_off",img:"assets/img/uv_off.svg",device_id:"UvLamp"},
    {device_status:"turn_on",img:"assets/img/uv-light.svg",device_id:"UvLamp"},
    {device_status:"turn_off",img:"assets/img/backwash_off.svg",device_id:"BackWash"},
    {device_status:"turn_on",img:"assets/img/backwash.svg",device_id:"BackWash"},
    {device_status:"turn_off",img:"assets/img/smartoff.svg",device_id:"PoolLight"},
    {device_status:"turn_on",img:"assets/img/pool-light-off.svg",device_id:"PoolLight"}
  ]


  

export interface TelemetryDetails {
  result:TelemetryValue[]
}

export interface TelemetryValue{
  _field:string,
  _value:string 
  }

export interface TelemetryDetailsWithoutGauge{
  value?:number,
  img?:string,
  unit?:string
}

export interface AlarmStructure{
  alert_code: string
  alert_id: string
  alert_identification_code: string
  alert_message: string
  alert_type: number
  bit_delete: number
  controller_uuid: string
  date_time: string
  device_id: string
  resolved_date_time?: string
}


export interface FilteredAlarmStructure {
  [date: string]: AlarmStructure[] ,
};

export interface DeviceDetais{
  device_id:string,
  controller_uuid:string,
  device_status?:string
  timeZone?:string
}
  
export interface AlarmGeneratedResolvedInterface{
  isAlarmGenerated:boolean ,
  timeZone?:string
}

export interface GaugeChartInterface{
  fieldList:string[],
  selectedValue:MetricOption,
  arcWidth:number,
  gaugeSegmentModel?:number[],
  yAxis:number,
  yAxisLabel:number,
  
}

export interface aggregationFilterInterface{
  aggregationFilter?:string,
  label?:string
}
